import * as Scrivito from "scrivito";

const TextMediaWidget = Scrivito.provideWidgetClass("TextMediaWidget", {
  attributes: {
    body: "html",
    complementaryText: "html",
    contactIconAltTxt: "string",
    contactFormLinkTxt: "string",
    contactPerson: ["reference", { only: ["Contact"] }],
    links: "linklist",
    media: ["reference", { only: ["Image", "ContactImage", "VideoVimeo"] }],
    mediaPosition: ["enum", { values: ["left", "right"] }],
    mediaSize: ["enum", { values: ["small", "large"] }],
    subtitle: "string",
    title: "string",
    toUppercase: ["enum", { values: ["yes", "no"] }],
    showContactIcon: ["enum", { values: ["yes", "no"] }],
  },
  extractTextAttributes: ["title", "subtitle", "body"],
});

export default TextMediaWidget;
